import { createTheme, MantineColorsTuple, MantineTheme } from '@mantine/core';
import type { ButtonProps } from '@mantine/core';

const manifestusDark: MantineColorsTuple = [
  '#f8f9fa',
  '#e9ecef',
  '#dee2e6',
  '#ced4da',
  '#adb5bd',
  '#868e96',
  '#495057',
  '#343a40',
  '#212529',
  '#1a1a1a',
];

const manifestusPurple: MantineColorsTuple = [
  '#f5f3ff',
  '#ede9fe',
  '#ddd6fe',
  '#c4b5fd',
  '#a78bfa',
  '#8b5cf6',
  '#7c3aed',
  '#6d28d9',
  '#5b21b6',
  '#4c1d95',
];

export const theme = createTheme({
  primaryColor: 'manifestusDark',
  colors: {
    manifestusDark,
    manifestusPurple,
    dark: [
      '#C1C2C5',
      '#A6A7AB',
      '#909296',
      '#5C5F66',
      '#373A40',
      '#2C2E33',
      '#25262B',
      '#1A1B1E',
      '#141517',
      '#101113',
    ],
  },
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  headings: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontWeight: '700',
  },
  defaultRadius: 'md',
  cursorType: 'pointer',
  components: {
    Button: {
      defaultProps: { radius: 'md' },
      vars: (_theme: MantineTheme, props: ButtonProps) => {
        if (props.color === 'dark' && (!props.variant || props.variant === 'filled')) {
          return {
            root: {
              '--button-bg': '#0a0a0a',
              '--button-hover': '#252525',
              '--button-color': '#fff',
              '--button-hover-color': '#fff',
            },
          };
        }
        return { root: {} };
      },
    },
    Card: {
      defaultProps: { radius: 'lg' },
      styles: {
        root: {
          background: '#fff',
          border: '1px solid #e9ecef',
        },
      },
    },
    Paper: {
      styles: {
        root: {
          background: '#fff',
          border: '1px solid #e9ecef',
        },
      },
    },
    Notification: {
      styles: {
        root: {
          background: '#fff',
          border: '1px solid #e9ecef',
          boxShadow: '0 4px 12px rgba(0,0,0,.08)',
        },
      },
    },
    Modal: {
      styles: {
        header: {
          background: '#fff',
          borderBottom: '1px solid rgba(0,0,0,.06)',
        },
        body: { background: '#fff' },
        content: {
          background: '#fff',
          border: '1px solid rgba(0,0,0,.06)',
          borderRadius: 12,
          boxShadow: '0 20px 60px rgba(0,0,0,.12)',
        },
      },
    },
    Menu: {
      styles: {
        dropdown: {
          background: '#fff',
          border: '1px solid rgba(0,0,0,.06)',
          boxShadow: '0 8px 30px rgba(0,0,0,.1)',
        },
      },
    },
    Tooltip: {
      defaultProps: { withArrow: true },
      styles: {
        tooltip: {
          background: '#0a0a0a',
          color: '#fff',
          fontSize: 12,
          fontWeight: 500,
        },
      },
    },
    Tabs: {
      styles: {
        tab: {
          fontWeight: 500,
          '&[data-active]': {
            borderColor: '#7c3aed',
            color: '#7c3aed',
          },
        },
      },
    },
    Switch: {
      defaultProps: { color: 'manifestusPurple' },
    },
    Progress: {
      defaultProps: { color: 'manifestusPurple' },
    },
    Badge: {
      defaultProps: { radius: 'sm' },
    },
    TextInput: {
      defaultProps: { radius: 'md' },
    },
    Textarea: {
      defaultProps: { radius: 'md' },
    },
    Select: {
      defaultProps: { radius: 'md' },
    },
    Accordion: {
      styles: {
        item: {
          borderColor: 'rgba(0,0,0,.06)',
        },
        control: {
          '&:hover': {
            background: 'rgba(0,0,0,.02)',
          },
        },
      },
    },
    Divider: {
      styles: {
        root: {
          borderColor: 'rgba(0,0,0,.06)',
        },
      },
    },
  },
});
